import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subAccessMatrixReducer() {
    return combineReducers({
        EmployeesAccessMatrix_ListSubForPO: createItemReducer("SubAccessMatrix", "PersonalCard.ListSubForNewPO", false),
        EmployeesAccessMatrix_ListSubForPOParams: createItemReducerParams("SubAccessMatrix", "PersonalCard.ListSubForNewPO"),
        EmployeesAccessMatrix_ListWSForPO: createItemReducer("SubAccessMatrix", "ComMonTune.ListWSForNewPO", false),
        EmployeesAccessMatrix_ListAddWSForPO: createItemReducer("SubAccessMatrix", "ComMonTune.ListAddWSForNewPO", false)
    });
}